<template lang="html">
  <div id="app" class="main column">
		<my-header :menu="menu" @notif-open="notifPanelActive = true" :notif="true" :help="true"></my-header>
		<div class="page column">
			<router-view></router-view>
		</div>
		<notification-panel />
<!--		<tutorial />-->
		<onboarding />
		<cookie />
		<my-footer />
  </div>
</template>

<script>
import NotificationPanel from '@/common/components/notification-panel'
import myHeader from '@/common/components/header'
import Cookie from '@/common/components/cookie'
import myFooter from '@/common/components/footer'
import Onboarding from '@/common/components/Onboarding/Onboarding'

export default {
	name: 'Main',
	components: {
		myHeader,
		NotificationPanel,
		Cookie,
		myFooter,
		Onboarding
	},
	data () {
		return {
			menu: [
				{
					key: 0,
					name: '<span class="icon-nav-actu"></span> Actualités',
					uri: 'IndexActualities'
				},
				{
					key: 1,
					name: '<span class="icon-nav-placements"></span> Mes placements',
					uri: 'MyInvestments'
				},
				{
					key: 2,
					name: '<span class="icon-nav-conseiller"></span> Conseiller',
					uri: 'Advisor'
				},
				{
					key: 3,
					name: '<span class="icon-nav-docs"></span> Mes documents',
					uri: 'Documents'
				}
			]
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/Main.vue